module.exports = __webpack_public_path__ + "static/media/Checkmark_solid.abd08089.svg";